import Animation from './animation'

/*
 * Used to simply update all points and paths for the line
 * drawing
 */
class BasicAnimation extends Animation {

  match (serie) {
    return true // This should run last and do a basic update if another animation didn't run
  }

  animate (serie, entering, selection, merged, exiting) {
    this._rebindPaths(merged, serie.points)

    this._updateDrawing(merged)
  }

}

export default BasicAnimation
